import { DEFAULT_SEARCH_RESULT_IMAGE_URL } from '../constants';
import { EventSearchObject, EventSearchResult } from './types';

export const convertSearchObjectToSearchResult = ({
  id,
  url,
  relatedPageUid,
  title,
  description,
  image,
  label,
  categories,
  type,
  eventTimestamp,
  updatedAt,
}: EventSearchObject): EventSearchResult => {
  let parsedImage: EventSearchResult['image'] | undefined;

  if (image) {
    try {
      const imageArray = JSON.parse(image);
      const firstImage = Array.isArray(imageArray) ? imageArray[0] : imageArray;

      if (firstImage && firstImage.gatsbyImageData) {
        parsedImage = {
          url: firstImage.url || '',
          data: {
            gatsbyImageData: firstImage.gatsbyImageData,
          },
        };
      }
    } catch {
      // If parsing fails, use default image
      parsedImage = {
        url: DEFAULT_SEARCH_RESULT_IMAGE_URL,
        data: null,
      };
    }
  }

  return {
    id,
    relatedPageUid,
    updatedAt,
    url,
    title,
    description,
    image: parsedImage,
    categories,
    label,
    type,
    eventTimestamp,
  };
};
